module.exports = __webpack_public_path__ + "img/download.6ff87845.svg";